export default "__VITE_ASSET__DCRgCzhJ__"